module.exports = __webpack_public_path__ + "static/media/icono_perfil_docente.a613a6e7.svg";